import cat from '../assets/img/avatar/Icon_cat_1.png'
import dog from '../assets/img/avatar/Icon_dog_1.png';
import ferret from '../assets/img/avatar/Icon_ferret_1.png';
import generic from '../assets/img/avatar/Icon_generic pet_1.png';

export  const AnimalAvatar = (type) => {
    
    switch(type){
        case 'Cão' : return dog;
        case 'Gato' : return cat;
        default : return generic;
    }
}